import { render, staticRenderFns } from "./count-section.vue?vue&type=template&id=62d1cb1f&scoped=true&"
import script from "./count-section.vue?vue&type=script&lang=js&"
export * from "./count-section.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d1cb1f",
  null
  
)

export default component.exports